import { Product } from "./product";
import { ProductFamily } from "./product-family";

export enum ProductFamilyType {
  CS_DUO,
  SWISS_SME,
  CS_SINGLE,
  SC_SINGLE,
}

export enum ProductRefType {
  SWISS_SILVER = "swiss-silver",
  SWISS_GOLD = "swiss-gold",
  SWISS_PLATINUM = "swiss-platinum",
  CS_DUO_SILVER = "cs-duo-silver",
  CS_DUO_GOLD = "cs-duo-gold",
  CS_MASTERCARD_BUSINESS_STANDARD_CHF = "cs-mastercard-business-standard-chf",
  CS_MASTERCARD_BUSINESS_GOLD_CHF = "cs-mastercard-business-gold-chf",
  CS_MASTERCARD_BUSINESS_EURO = "cs-mastercard-business-euro",
  SC_MASTERCARD_BUSINESS_SILVER_CHF = "sc-mastercard-business-silver-chf",
  SC_MASTERCARD_BUSINESS_GOLD_CHF = "sc-mastercard-business-gold-chf",
  SC_MASTERCARD_BUSINESS_GOLD_EUR = "sc-mastercard-business-gold-eur",
  SC_MASTERCARD_BUSINESS_CORPORATE_USD = "sc-mastercard-business-corporate-usd",
}

export interface ProductContextType {
  selectedProduct: Product;
  setSelectedProduct: (newProduct: Product, skipSync?: boolean) => void;
  findProduct: (productRef: ProductRefType) => Product;
  findPersistedProductByRef: (productRef: ProductRefType) => Product;
  findFamily: (name: ProductFamily["name"]) => ProductFamily;
  findFamilyFromAll: (name: ProductFamily["name"]) => ProductFamily;
  findProductIfValid: (productRef: ProductRefType) => Product;
  resetProductToDefault: () => void;
}
